import { AtText } from '../../atoms';
import { IDesignStudio } from '../../organisms/or-design-studio-block/or-design-studio-block.types';

export const AddressGenerator = ({
  studioData,
}: {
  studioData: IDesignStudio | null;
}) => {
  if (!studioData || studioData.IsVirtual) return <></>;
  const hasAllCustom =
    Boolean(studioData.CsAddress) &&
    Boolean(studioData.CsCity) &&
    Boolean(studioData.CsState) &&
    Boolean(studioData.CsZip);

  const address = hasAllCustom ? studioData.CsAddress : studioData.Address;
  const city = hasAllCustom ? studioData.CsCity : studioData.City;
  const state = hasAllCustom ? studioData.CsState : studioData.State;
  const zip = hasAllCustom ? studioData.CsZip : studioData.Zip;

  return (
    <AtText>
      {address}, {city}
      <br />
      {state}, {zip}
    </AtText>
  );
};
